import { Dispatch, SetStateAction, useEffect, useState } from "react"
import { HStack, Tag } from "@chakra-ui/react"
import useGridPageStyling from "../hooks/useGridPageStyling"
import { useIsMobileDevice } from "src/util/browser"
import {
  InspirationCategoryModel,
  useInspirationCategories
} from "src/hooks/useInspirationCategories"

type CategoryTagProps = {
  category: InspirationCategoryModel
  isSelected: boolean
  onSelected: (selected: InspirationCategoryModel) => void
}

const CategoryTag = ({
  category,
  isSelected,
  onSelected
}: CategoryTagProps) => {
  const branding = useGridPageStyling()
  const isMobile = useIsMobileDevice()

  const styling = isSelected
    ? {
        background: branding.panelMouseoverBackgroundColor,
        color: branding.panelMouseoverTextColor,
        borderColor: branding.panelMouseoverBorderColor
      }
    : {
        background: branding.panelBackgroundColor,
        color: branding.panelTextColor,
        borderColor: branding.panelBorderColor
      }

  return (
    <Tag
      size="lg"
      borderRadius="full"
      variant="solid"
      borderWidth={1}
      whiteSpace="nowrap"
      minW={"unset"}
      onClick={() => onSelected(category)}
      userSelect={"none"}
      _hover={
        !isMobile
          ? {
              background: branding.panelMouseoverBackgroundColor,
              color: branding.panelMouseoverTextColor,
              borderColor: branding.panelMouseoverBorderColor
            }
          : {}
      }
      cursor="pointer"
      {...styling}
    >
      {category.name}
    </Tag>
  )
}

type Props = {
  onChanged: Dispatch<SetStateAction<InspirationCategoryModel | null>>
}

const InspirationCategoriesRow = ({ onChanged }: Props) => {
  const [selectedAvatarCategory, setSelectedAvatarCategory] =
    useState<InspirationCategoryModel | null>(null)

  const { categories } = useInspirationCategories()

  useEffect(() => {
    if (onChanged) onChanged(selectedAvatarCategory)
  }, [selectedAvatarCategory])

  return (
    <HStack overflowX="auto" className="hide-scrollbar">
      {categories?.map(category => (
        <CategoryTag
          key={`avatar-categories-${category.id}`}
          category={category}
          isSelected={category.id === selectedAvatarCategory?.id}
          onSelected={selectedCategory => {
            setSelectedAvatarCategory(prevCategory => {
              if (prevCategory?.id === selectedCategory?.id) {
                return null
              }
              return selectedCategory
            })
          }}
        />
      ))}
    </HStack>
  )
}

export default InspirationCategoriesRow
